import React, { useState, useEffect } from "react";
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  StyleSheet,
  Modal,
  ScrollView,
  ActivityIndicator,
  FlatList,
} from "react-native";

import Fonts from "../../Resources/Fonts";
import Colors from "../../Resources/Color";
import GlobalStyles from "../../Resources/Styles";

import { Menu, MenuItem } from "react-native-material-menu";
import { useScreenDimensions, useDevice } from "../_layout";

import { observer, Observer } from "mobx-react";

import { MaterialIcons } from "@expo/vector-icons";
import { AntDesign } from "@expo/vector-icons";
import { Feather } from "@expo/vector-icons";
import Ionicons from "@expo/vector-icons/Ionicons";
import { Octicons } from "@expo/vector-icons";

import { v4 as uuidv4 } from "uuid";
import IconEmptyView from "../Components/IconEmptyView";

import { useTranslation } from "react-i18next";
import SearchBar from "../Components/SearchBar";

import { useDebounce } from "use-debounce";

import { useInfiniteQuery } from "@tanstack/react-query";
import axios from "axios";
import { formatNumber } from "../utils/numberUtils";

const AddFoodView = ({ isVisible, onClose, foodOption, food, coach }) => {
  const { t } = useTranslation();
  const { screenSize } = useScreenDimensions();
  const { isMobile } = useDevice();

  const cancel = () => {
    //   client.resetAuxNutritionPlan();
    //   if (nutritionPlan) {
    //     nutritionPlan.setProperty("isSelected", false);
    //   }
    onClose();
  };

  const OFF_SEARCH_URL = "https://world.openfoodfacts.org/cgi/search.pl";
  const PAGE_SIZE = 20;

  function useFoodSearch(searchTerm) {
    return useInfiniteQuery({
      queryKey: ["foodSearch", searchTerm],
      queryFn: ({ pageParam = 0 }) =>
        axios
          .get(OFF_SEARCH_URL, {
            params: {
              search_terms: searchTerm,
              search_simple: 1,
              json: 1,
              page: pageParam + 1, // OFF is 1-indexed
              page_size: PAGE_SIZE,
            },
          })
          .then((res) => res.data.products),
      enabled: Boolean(searchTerm),
      getNextPageParam: (lastPage, allPages) =>
        lastPage.length === PAGE_SIZE ? allPages.length : undefined,
      select(data) {
        const all = data.pages.flat();
        const clean = all.filter(
          (item) =>
            item.product_name &&
            item.brands?.trim() &&
            item.nutriments?.["energy-kcal_value"] != null &&
            item.nutriments?.carbohydrates_value != null &&
            item.nutriments?.proteins_value != null &&
            item.nutriments?.fat_value != null
        );
        return {
          pages: [clean],
          pageParams: data.pageParams,
        };
      },
    });
  }

  function rankFoods(list, term) {
    const t = term.trim().toLowerCase();

    function namesOf(item) {
      return [
        item.product_name_es,
        item.generic_name_es,
        item.product_name,
        item.generic_name,
      ]
        .filter(Boolean)
        .map((s) => s.toLowerCase());
    }

    return (
      list &&
      list
        .map((item) => {
          let score = 0;
          const names = namesOf(item);

          // 1) exact
          if (names.some((n) => n === t)) score += 100;
          // 2) prefix
          else if (names.some((n) => n.startsWith(t))) score += 50;
          // 3) substring
          else if (names.some((n) => n.includes(t))) score += 10;

          // 4) Hacendado brand boost
          if (
            item.brands
              .toLowerCase()
              .split(/[,;]/) // allow “brand1, brand2”
              .map((b) => b.trim())
              .includes("hacendado")
          ) {
            score += 20;
          }

          return { item, score };
        })
        // only keep hits
        .filter(({ score }) => score > 0)
        // highest first
        .sort((a, b) => b.score - a.score)
        .map(({ item }) => item)
    );
  }

  const [term, setTerm] = useState("");
  const [debouncedTerm] = useDebounce(term, 1000);

  const {
    data,
    isLoading,
    isError,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useFoodSearch(debouncedTerm);

  //   if (!debouncedTerm) {
  //     return (
  //       <View style={{ padding: 16 }}>
  //         <TextInput
  //           placeholder="Search foods…"
  //           value={term}
  //           onChangeText={setTerm}
  //           style={{
  //             padding: 8,
  //             borderBottomWidth: 1,
  //             borderColor: "#ccc",
  //           }}
  //         />
  //       </View>
  //     );
  //   }

  //   if (isLoading) {
  //     return <ActivityIndicator style={{ flex: 1, marginTop: 20 }} />;
  //   }
  //   if (isError) {
  //     return <Text style={{ padding: 20 }}>Oops, something went wrong.</Text>;
  //   }

  const client = foodOption.meal.nutritionPlan.client;

  // const coach = foodOption.meal.nutritionPlan.coach;

  const items = data?.pages.flat();
  const filteredAndRanked = rankFoods(items, debouncedTerm);

  const [showingCustomFoods, setShowingCustomFoods] = useState(false); //Valorar que estigui a coach

  const ProductCard = observer(({ item }) => {
    const [isHovered, setIsHovered] = useState(false);

    const name = item.product_name || item.generic_name || "—";

    // List out the macros you care about, with the OFF key and the unit you want
    const macros = [
      { key: "energy-kcal_value", label: "Energy", unit: "kcal" },
      { key: "carbohydrates_value", label: "Carbs", unit: "g" },
      { key: "proteins_value", label: "Protein", unit: "g" },
      { key: "fat_value", label: "Fat", unit: "g" },
      { key: "sugars_value", label: "Sugars", unit: "g" },
    ];

    // const isSelected = foodOption
    //   ? foodOption.foods.some((f) => item.code && f.code === item.code)
    //   : food &&
    //     food.equivalences.some((f) => item.code && f.code === item.code);

    const isSelected = food
      ? food.equivalences.some((f) => item.code && f.code === item.code)
      : foodOption.foods.some((f) => item.code && f.code === item.code);

    return (
      <TouchableOpacity
        style={{
          padding: 8,
          borderBottomWidth: 1,
          borderColor: "#eee",
          flexDirection: "row",
          backgroundColor: isSelected
            ? "rgba(63, 123, 141, 0.5)"
            : isHovered
            ? "rgba(0, 0, 0, 0.05)"
            : "transparent",
          opacity: isSelected && isHovered ? 0.7 : 1,
        }}
        onPress={() => {
          if (food) {
            food.selectEquivalence(item);
          } else {
            foodOption.selectFoodItem(item);
          }
        }}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <View style={{ flex: 1, paddingRight: 8 }}>
          <Text
            style={{ flex: 1, fontSize: 12, fontWeight: "600" }}
            numberOfLines={2}
          >
            {name}
          </Text>
          {item.brands && (
            <Text style={{ fontSize: 10, color: "#666" }}>
              {item.brands || ""}
            </Text>
          )}
        </View>
        {macros.map(({ key, label, unit }) => {
          const value = item.nutriments?.[key];
          return (
            <View key={key} style={{ alignItems: "center", minWidth: 40 }}>
              <Text style={{ fontSize: 10, color: "#666" }}>{label}</Text>
              <Text style={{ fontSize: 12, fontWeight: "500" }}>
                {value != null ? `${formatNumber(value)}${unit}` : "—"}
              </Text>
            </View>
          );
        })}
      </TouchableOpacity>
    );
  });

  const HistoryFoodRow = observer(({ historyFood }) => {
    const [isHovered, setIsHovered] = useState(false);

    const macros = [
      { key: "calories", label: "Energy", unit: "kcal" },
      { key: "carbs", label: "Carbs", unit: "g" },
      { key: "protein", label: "Protein", unit: "g" },
      { key: "fats", label: "Fats", unit: "g" },
    ];

    // const isSelected = foodOption.foods.some(
    //   (f) => historyFood.code && f.code === historyFood.code
    // );
    const isSelected = food
      ? food.equivalences.some(
          (f) => historyFood.code && f.code === historyFood.code
        )
      : foodOption.foods.some(
          (f) => historyFood.code && f.code === historyFood.code
        );

    return (
      <TouchableOpacity
        style={{
          padding: 8,
          borderBottomWidth: 1,
          borderColor: "#eee",
          flexDirection: "row",
          backgroundColor: isSelected
            ? "rgba(63, 123, 141, 0.5)"
            : isHovered
            ? "rgba(0, 0, 0, 0.05)"
            : "transparent",
          opacity: isSelected && isHovered ? 0.7 : 1,
          alignItems: "center",
        }}
        // onPress={() => foodOption.selectHistoryFood(historyFood)}
        onPress={() => {
          if (food) {
            food.addEquivalence(null, historyFood);
          } else {
            foodOption.selectHistoryFood(historyFood);
          }
        }}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <View style={{ flex: 1, paddingRight: 8 }}>
          <Text style={{ flex: 1, fontSize: 12, fontWeight: "600" }}>
            {historyFood.name}
          </Text>
          {historyFood.brand && (
            <Text style={{ fontSize: 10, color: "#666" }}>
              {historyFood.brand || "Unknown brand"}
            </Text>
          )}
        </View>
        {macros.map(({ key, label, unit }) => {
          const value = historyFood.getProperty(key);
          return (
            <View key={key} style={{ alignItems: "center", minWidth: 40 }}>
              <Text style={{ fontSize: 10, color: "#666" }}>{label}</Text>
              <Text style={{ fontSize: 12, fontWeight: "500" }}>
                {value != null ? `${formatNumber(value)}${unit}` : "—"}
              </Text>
            </View>
          );
        })}
      </TouchableOpacity>
    );
  });

  const TabBar = () => {
    const TabButton = observer(({ isCustom }) => {
      const [isHovered, setIsHovered] = useState(false);

      const handlePress = () => {
        setShowingCustomFoods(isCustom);
      };

      const isActive = isCustom === showingCustomFoods;

      return (
        <TouchableOpacity
          onPress={handlePress}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View style={{ alignItems: "center" }}>
            <Text
              style={[
                styles.tabText,
                {
                  color:
                    isActive || isHovered
                      ? Colors.bubbleColor
                      : Colors.blackColor,
                },
              ]}
            >
              {isCustom ? t("customFoods-string") : t("foods-string")}
            </Text>
            <View
              style={[
                styles.underline,
                {
                  backgroundColor: isActive
                    ? Colors.bubbleColor
                    : "transparent",
                },
              ]}
            />
          </View>
        </TouchableOpacity>
      );
    });

    return (
      <View
        style={[
          GlobalStyles.HStack,
          {
            marginVertical: 20,
            justifyContent: "space-evenly",
            // flex: 1,
            flexDirection: "row",
          },
        ]}
      >
        <TabButton isCustom={false} />
        <TabButton isCustom={true} />
      </View>
    );
  };

  const ClientOrCoachFoods = observer(({ searchTerm }) => {
    const foods = client ? client.foodHistory : coach ? coach.foods : null;

    const filteredFoods = foods
      ? searchTerm !== ""
        ? foods.filter((food) =>
            food.name.toLowerCase().includes(searchTerm.toLowerCase())
          )
        : foods
      : null;

    return (
      filteredFoods &&
      filteredFoods.length > 0 && (
        <View>
          {/* {client && (
            <Text onPress={() => console.log(filteredFoods)}>
              {t("clientHistoryFoodsDots-string")}
              {filteredFoods.length}
            </Text>
          )} */}
          {coach && (
            <Text
              style={{
                color: Colors.grayColor,
                marginBottom: 8,
              }}
              onPress={() => console.log(filteredFoods)}
            >
              {t("customFoods-string")}
            </Text>
          )}

          <FlatList
            data={filteredFoods}
            keyExtractor={(item) => item.id.toString()}
            renderItem={({ item }) => <HistoryFoodRow historyFood={item} />}
            // style={{ backgroundColor: "red" }}
          />
        </View>
      )
    );

    // return client ? (
    //   <FlatList
    //     data={client.foodHistory}
    //     keyExtractor={(item) => item.id.toString()}
    //     renderItem={({ item }) => <HistoryFoodRow historyFood={item} />}
    //   />
    // ) : coach ? (
    //   <FlatList
    //     data={coach.foods}
    //     keyExtractor={(item) => item.id.toString()}
    //     renderItem={({ item }) => <HistoryFoodRow historyFood={item} />}
    //   />
    // ) : (
    //   <Text>Empty View</Text>
    // );
  });

  const CoachFoods = observer(({ searchTerm }) => {
    const foods = coach ? coach.foods : null;

    const filteredFoods = foods
      ? searchTerm !== ""
        ? foods.filter((food) =>
            food.name.toLowerCase().includes(searchTerm.toLowerCase())
          )
        : foods
      : null;

    return (
      filteredFoods &&
      filteredFoods.length > 0 && (
        <View>
          {coach && (
            <Text
              style={{
                color: Colors.grayColor,
                marginBottom: 8,
              }}
            >
              {t("customFoods-string")}
            </Text>
          )}

          <FlatList
            data={filteredFoods}
            keyExtractor={(item) => item.id.toString()}
            renderItem={({ item }) => <HistoryFoodRow historyFood={item} />}
          />
        </View>
      )
    );
  });

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={isVisible}
      onRequestClose={cancel}
    >
      <View style={GlobalStyles.centeredView}>
        <View style={GlobalStyles.touchableBackground} />
        <View
          style={[
            styles.modalView,
            {
              minHeight: screenSize != "large" ? 200 : 500,
              padding: screenSize === "small" ? 8 : 12,
              width: screenSize === "small" ? "90%" : 480,
            },
          ]}
          onStartShouldSetResponder={() => false}
        >
          <View style={{ alignItems: "flex-end" }}>
            <TouchableOpacity onPress={() => onClose()}>
              <Feather
                name="x"
                size={24}
                color={Colors.grayColor}
                style={{
                  paddingHorizontal: 4,
                  paddingTop: 4,
                }}
              />
            </TouchableOpacity>
          </View>

          <Text style={[Fonts.bold18Centered, { marginTop: -16 }]}>
            {t(food ? "addEquivalences-string" : "addFood-string")}
          </Text>

          {/* <TabBar /> */}

          {/* <TextInput
            placeholder="Search foods…"
            value={term}
            onChangeText={setTerm}
            style={{
              padding: 8,
              borderBottomWidth: 1,
              borderColor: "#ccc",
            }}
          /> */}

          <SearchBar
            text={term}
            onChangeText={(text) => setTerm(text)}
            placeholder={"searchFoods-string"}
            maxWidth={"100%"}
          />

          {/* <ClientOrCoachFoods searchTerm={term} /> */}
          <CoachFoods searchTerm={term} />

          {filteredAndRanked && (
            <FlatList
              data={filteredAndRanked}
              keyExtractor={(item) => item.code}
              renderItem={({ item }) => <ProductCard item={item} />}
              ListFooterComponent={() =>
                hasNextPage ? (
                  <TouchableOpacity
                    onPress={() => fetchNextPage()}
                    style={{
                      padding: 12,
                      marginVertical: 16,
                      backgroundColor: "rgba(0, 0, 0, 0.1)",
                      borderRadius: 4,
                      alignItems: "center",
                    }}
                  >
                    {isFetchingNextPage ? (
                      <ActivityIndicator />
                    ) : (
                      <Text>{t("seeMore-string")}</Text>
                    )}
                  </TouchableOpacity>
                ) : null
              }
            />
          )}

          {/* {filteredAndRanked ? (
            <FlatList
              data={filteredAndRanked}
              keyExtractor={(item) => item.code}
              renderItem={({ item }) => <ProductCard item={item} />}
              ListFooterComponent={() =>
                hasNextPage ? (
                  <TouchableOpacity
                    onPress={() => fetchNextPage()}
                    style={{
                      padding: 12,
                      margin: 16,
                      backgroundColor: "#eee",
                      borderRadius: 4,
                      alignItems: "center",
                    }}
                  >
                    {isFetchingNextPage ? (
                      <ActivityIndicator />
                    ) : (
                      <Text>Load more...</Text>
                    )}
                  </TouchableOpacity>
                ) : null
              }
            />
          ) : client ? (
            <Observer>
              {() => (
                <FlatList
                  data={client.foodHistory}
                  keyExtractor={(item) => item.id.toString()}
                  renderItem={({ item }) => (
                    <HistoryFoodRow historyFood={item} />
                  )}
                />
              )}
            </Observer>
          ) : coach ? (
            <Observer>
              {() => (
                <FlatList
                  data={coach.foods}
                  keyExtractor={(item) => item.id.toString()}
                  renderItem={({ item }) => (
                    <HistoryFoodRow historyFood={item} />
                  )}
                />
              )}
            </Observer>
          ) : (
            <Text>Empty View</Text>
          )} */}
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalView: {
    position: "absolute",
    maxHeight: "95%",
    borderRadius: 18,
    backgroundColor: Colors.whiteColor,
    gap: 16,
  },
  tabText: {
    fontSize: 13,
    fontWeight: "500",
  },
  underline: {
    height: 2,
    width: "100%",
    alignSelf: "center",
    marginTop: 2,
  },
});

export default AddFoodView;
